<template>
    <sirit-modal v-if="global.getConfirmDate() !== null && global.isFree() && global.getDiffDate() !== 0 && openModal">
        <template v-slot:modalContent>
            <div class="flex justify-center items-center flex-col">
                <div class="modal-header w-full flex flex-shrink-0 border-b border-gray-200 rounded-t-md">
                    <span @click="closeModal()" class="cursor-pointer font-bold text-xl hover:text-sirit_blue-400">x</span>
                    <span class="text-md ml-2 text-black mt-1">Cerrar</span>
                </div>
                <div class="w-full h-full py-20 text-center ">
                    Su plan
                    <span class="font-bold">{{global.getUserPlanSession().name}}</span>
                    {{  90 > global.getDiffDate() ? 'está a punto de caducar' : 'ha caducado' }}
                    <div class="mt-5" v-if="90 - global.getDiffDate() > 0">{{`Falta${90 - global.getDiffDate() > 1 ? 'n' : ''} ${ 90 - global.getDiffDate()} día${90 - global.getDiffDate() > 1 ? 's' : ''}`}}</div>
                </div>
                <div class="flow flex-col w-full col-span-2">
                    <div class="w-full flex flex-col max-w-xl mx-auto mt-4">
                        <button @click="type_ && type_ !== '' ? closeModal() : goRoute_() "  type="submit" class="w-full text-white py-3 px-6 mb-20 rounded-md  font-bold" :class="`bg-${colors.primary}-500 hover:bg-${colors.primary}-600`">Pasar a otro plan</button>
                    </div>
                </div>
            </div>
        </template>
    </sirit-modal>
</template>

<script lang="ts">
import {reactive, toRefs} from 'vue';
import {useRouter} from 'vue-router'
import * as global from '@/api/global'
import SiritModal from '@/components/Commons/SiritModal.vue'
import 'vue3-date-time-picker/dist/main.css'

export default {
  name: 'Warning',
  components: {SiritModal},
  props: {
    type_: { type: String, required: true, default: ''},
  },
  setup () {

    const state = global.state;
    const { colors } = state.configTenant.template;

    const router = useRouter();

    interface data_ {
        openModal: boolean
    }

    let data = reactive<data_>({
        openModal: false,
    })

    const closeModal = () => {
        data.openModal = false;
    }

    const isWarning = () => {
        if(global.getConfirmDate() !== null && global.getDiffDate() !== 0){
            data.openModal = true;
        }
    }

    const goRoute_ = () => {
      router.push({ name: 'newContract', params: {type: 'change'} });
    }

    isWarning();

    return {
      closeModal,
      global,
      data,
      isWarning,
      goRoute_,
      colors,
      ...toRefs(data)
    }

  }

}

</script>


